export default {
    state: {
        storageStock: {},
        product: null,
        productId: null,
        storage: null,
        supplier: null,
        storageInDialog: null,
        loading: false,
        currentPage: 1,
        sorting: {
            prop: 'product_name',
            order: 'ascending',
        },
        supplierOrderLoading: false,
        customerOrderLoading: false,
        representativeOrderLoading: false,
        supplierOrders: [],
        customerOrders: [],
        representativeOrders: [],
    },
    getters: {
        storageStock: state => state.storageStock,
        loading: state => state.loading,
        currentPage: state => state.currentPage,
        supplierOrders: state => state.supplierOrders,
        customerOrders: state => state.customerOrders,
        representativeOrders: state => state.representativeOrders,
    },
    mutations: {
        setStorageStock(state, storageStock) {
            state.storageStock = storageStock;
        },
        setCurrentPage(state, currentPage) {
            state.currentPage = currentPage;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setSorting(state, sorting) {
            state.sorting = sorting;
        },
        setProduct(state, product) {
            state.product = product;
        },
        setSupplier(state, supplier) {
            state.supplier = supplier;
        },
        setProductId(state, product) {
            state.productId = product;
        },
        setStorage(state, storage) {
            state.storage = storage;
        },
        setSupplierOrderLoading(state, val) {
            state.supplierOrderLoading = val;
        },
        setCustomerOrderLoading(state, val) {
            state.customerOrderLoading = val;
        },
        setRepresentativeOrderLoading(state, val) {
            state.representativeOrderLoading = val;
        },
        setSupplierOrders(state, val) {
            state.supplierOrders = val;
        },
        setCustomerOrders(state, val) {
            state.customerOrders = val;
        },
        setRepresentativeOrders(state, val) {
            state.representativeOrders = val;
        },
        setStorageInDialog(state, val) {
            state.storageInDialog = val;
        },
    },
    actions: {
        async fetchAll({commit, state, dispatch}, queryString) {
            commit('setLoading', true);
            try {
                let query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}`;

                if (state.product) {
                    query = query + '&product_id=' + state.product.id;
                }

                if (state.storage) {
                    query = query + '&storage_id=' + state.storage.id;
                }

                if (state.supplier) {
                    query = query + '&supplier_id=' + state.supplier.id;
                }

                const storageStock = await axios.get('api/reports/storage-stock' + query);
                commit('setStorageStock', storageStock);
            } catch (e) {
            }
            commit('setLoading', false);
        },

        async fetchUnaccomplished({commit, state, dispatch}) {
            commit('setRepresentativeOrderLoading', true)
            axios.get(`/api/reports/storage-stock/representative-orders/products/${state.productId}/storages/${state.storageInDialog.id}`).then((response) => {
                commit('setRepresentativeOrders', response);
                commit('setRepresentativeOrderLoading', false)
            });

            commit('setCustomerOrderLoading', true)
            axios.get(`/api/reports/storage-stock/customer-orders/products/${state.productId}/storages/${state.storageInDialog.id}`).then((response) => {
                commit('setCustomerOrders', response);
                commit('setCustomerOrderLoading', false)
            });

            commit('setSupplierOrderLoading', true)
            axios.get(`/api/reports/storage-stock/supplier-orders/products/${state.productId}/storages/${state.storageInDialog.id}`).then((response) => {
                commit('setSupplierOrders', response);
                commit('setSupplierOrderLoading', false)
            });
        },

        storageChanged({commit, state, dispatch}, storage) {
            commit('setStorageInDialog', storage);
            dispatch('fetchUnaccomplished');
        },

        productIdChanged({commit, dispatch}, productId) {
            commit('setProductId', productId);
            dispatch('fetchUnaccomplished');
        }
    },
};
